import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import DropZone from "../components/DropZone";
import { Copy, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function MediaLibrary() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { setLoading(true); const { data } = await api.get("/admin/media"); setItems(data); setLoading(false); };
  useEffect(() => { load(); }, []);

  const copy = (url) => {
    const full = `${process.env.REACT_APP_BACKEND_URL}${url}`;
    navigator.clipboard.writeText(full);
    toast.success("URL copiada.");
  };
  const remove = async (id) => {
    if (!window.confirm("Excluir esta imagem? (soft delete)")) return;
    await api.delete(`/admin/media/${id}`);
    load();
  };

  return (
    <div>
      <h1 className="font-display text-4xl mb-6">Biblioteca de mídia</h1>
      <DropZone multiple onUploaded={() => load()} />
      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3" data-testid="media-grid">
        {loading ? <div className="text-sm text-neutral-500">Carregando…</div> : items.map((m) => (
          <div key={m.id} className="group relative border border-black/10 rounded overflow-hidden">
            <img src={`${process.env.REACT_APP_BACKEND_URL}${m.url}`} alt={m.filename} className="w-full h-32 object-cover" />
            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition flex flex-col items-center justify-center gap-2">
              <button onClick={() => copy(m.url)} className="text-white text-xs flex items-center gap-1 bg-white/10 hover:bg-white/20 px-2 py-1 rounded" data-testid={`media-copy-${m.id.slice(0,6)}`}><Copy className="w-3 h-3" /> Copiar URL</button>
              <button onClick={() => remove(m.id)} className="text-red-300 text-xs flex items-center gap-1 hover:text-red-100"><Trash2 className="w-3 h-3" /> Excluir</button>
            </div>
            <div className="p-1 text-[10px] text-neutral-500 truncate">{m.filename}</div>
          </div>
        ))}
        {!loading && !items.length && <div className="text-sm text-neutral-500 col-span-full text-center py-12">Nenhuma mídia ainda.</div>}
      </div>
    </div>
  );
}
